import { FlightStatusForm } from '../../models/interfaces/flight-status-form.interface';

export class AirportConfigUtil {
  static getOriginPlaceholder(content?: FlightStatusForm): string {
    if (!content) return ''; // Return empty when no content - let error banner handle it
    return content.inputFields?.multiRoutePicker?.origin?.title || 'From';
  }

  static getOriginErrorMessage(content?: FlightStatusForm): string {
    if (!content) return ''; // Return empty when no content - let error banner handle it
    return (
      content.errorMessages?.['FROM_CITY_REQD']?.['description'] ||
      'Please enter an Origin'
    );
  }

  static getDestinationPlaceholder(content?: FlightStatusForm): string {
    if (!content) return ''; // Return empty when no content - let error banner handle it
    return content.inputFields?.multiRoutePicker?.destination?.title || 'To';
  }

  static getDestinationErrorMessage(content?: FlightStatusForm): string {
    if (!content) return ''; // Return empty when no content - let error banner handle it
    return (
      content.errorMessages?.['TO_CITY_REQD']?.['description'] ||
      'Please enter a Destination'
    );
  }

  static createAirportCodeConfig(content?: FlightStatusForm) {
    return {
      id: 'flight-status-airport-code',
      type: 'default' as const,
      originTrigger: {
        title: '',
        placeholder: this.getOriginPlaceholder(content),
        errorMessage: this.getOriginErrorMessage(content)
      },
      destinationTrigger: {
        title: '',
        placeholder: this.getDestinationPlaceholder(content),
        errorMessage: this.getDestinationErrorMessage(content)
      }
    };
  }
}
